<template>
  <div class="error error__404">
    404 not Found
  </div>
</template>

<script>
export default {};
</script>
